// Bike data structure for Pakistani bikes
export const bikeData = {
  Honda: {
    models: {
      "CD 70": {
        variants: {
          "Euro II": {},
          "Standard": {},
        }
      },
      "CG 125": {
        variants: {
          "Self Start": {},
          "Special": {},
          "Standard": {},
        }
      },
      "CB 150F": {
        variants: {
          "Standard": {},
        }
      },
      "Pridor": {
        variants: {
          "Standard": {},
        }
      },
      "CB 150R": {
        variants: {
          "Standard": {},
        }
      },
      "CD 70 Dream": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  Yamaha: {
    models: {
      "YBR 125": {
        variants: {
          "Standard": {},
        }
      },
      "YBR 125G": {
        variants: {
          "Standard": {},
        }
      },
      "YBZ 125": {
        variants: {
          "Standard": {},
        }
      },
      "R15": {
        variants: {
          "V3": {},
          "V2": {},
          "V1": {},
        }
      },
      "FZ 150": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  Suzuki: {
    models: {
      "GS 150": {
        variants: {
          "SE": {},
          "Standard": {},
        }
      },
      "GR 150": {
        variants: {
          "Standard": {},
        }
      },
      "GD 110S": {
        variants: {
          "Standard": {},
        }
      },
      "Gixxer": {
        variants: {
          "SF": {},
          "Standard": {},
        }
      },
      "GSX-R150": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  United: {
    models: {
      "US 70": {
        variants: {
          "Standard": {},
        }
      },
      "US 125": {
        variants: {
          "Standard": {},
        }
      },
      "US 100": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Road Prince": {
    models: {
      "RP 70": {
        variants: {
          "Standard": {},
        }
      },
      "WeGo 150": {
        variants: {
          "Standard": {},
        }
      },
      "RP 125": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  Kawasaki: {
    models: {
      "Ninja 250": {
        variants: {
          "Standard": {},
        }
      },
      "Ninja 300": {
        variants: {
          "Standard": {},
        }
      },
      "Ninja 650": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Super Power": {
    models: {
      "SP 70": {
        variants: {
          "Standard": {},
        }
      },
      "SP 125": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Hi Speed": {
    models: {
      "Infinity 150": {
        variants: {
          "Standard": {},
        }
      },
      "SR 70": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Super Star": {
    models: {
      "SS 70": {
        variants: {
          "Standard": {},
        }
      },
      "SS 125": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  Power: {
    models: {
      "PK 70": {
        variants: {
          "Standard": {},
        }
      },
      "PK 125": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Qingqi": {
    models: {
      "QM 125": {
        variants: {
          "Standard": {},
        }
      },
      "QM 150": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
  "Ravi": {
    models: {
      "Ravi 70": {
        variants: {
          "Standard": {},
        }
      },
      "Ravi 125": {
        variants: {
          "Standard": {},
        }
      },
    }
  },
};

